import { REQUIRED_APPROVERS } from '../../../administration/general.settings/types';
import { WorkflowStageStatus, WorkflowStageStatusText } from './types';

export function getWorkflowStageStatus (
  stageNumber: number,
  activeStageNumber: number,
  isInReview: boolean,
): WorkflowStageStatus {
  if (isInReview) {
    return WorkflowStageStatus.IN_REVIEW;
  }

  if (stageNumber < activeStageNumber) {
    return WorkflowStageStatus.COMPLETED;
  }

  if (stageNumber === activeStageNumber) {
    return WorkflowStageStatus.IN_PROGRESS;
  }

  return WorkflowStageStatus.PENDING;
}

export function getWorkflowStageStatusText (
  stageNumber: number,
  activeStageNumber: number,
  isInReview: boolean,
): WorkflowStageStatusText {
  if (isInReview) {
    return WorkflowStageStatusText.IN_REVIEW;
  }

  if (stageNumber < activeStageNumber) {
    return WorkflowStageStatusText.COMPLETED;
  }

  if (stageNumber === activeStageNumber) {
    return WorkflowStageStatusText.IN_PROGRESS;
  }

  return WorkflowStageStatusText.PENDING;
}

export const getRequiredCountLabel = (
  requiredCount: REQUIRED_APPROVERS,
): string => {
  switch (requiredCount) {
    case REQUIRED_APPROVERS.ALL:
      return 'All Required';

    case REQUIRED_APPROVERS.ANY_ONE:
      return 'Any One Required';

    case REQUIRED_APPROVERS.ANY_TWO:
      return 'Any Two Required';

    default:
      return requiredCount;
  }
};
